import {
	LAST_ROUTE,
	MOCK_PERMISSIONS,
	NEW_ORG_ID,
	RoutePermType,
	SELECTED_ORG,
	USER_ORGS,
	routes,
} from "../constants";
import { OrgAndPermsDto } from "../types/dto";

export const selectedOrgLS = () =>
	JSON.parse(localStorage.getItem(SELECTED_ORG) || "{}") as
		| OrgAndPermsDto
		| { id: null };
export const selectedOrgIdLS = () => selectedOrgLS().id;
export const userOrgsLS = () =>
	JSON.parse(
		localStorage.getItem(USER_ORGS) || "[]"
	) as Array<OrgAndPermsDto>;
export const newOrgIdLS = () => {
	const newOrgId = localStorage.getItem(NEW_ORG_ID);
	localStorage.removeItem(NEW_ORG_ID);
	return newOrgId;
};
export const setNewOrgIdLS = (orgId: string) =>
	localStorage.setItem(NEW_ORG_ID, orgId);

export const getMockPerms = () =>
	localStorage.getItem(MOCK_PERMISSIONS)
		? JSON.parse(localStorage.getItem(MOCK_PERMISSIONS) || "{}")
		: null;
export const setMockPerms = (newPerms: RoutePermType) =>
	localStorage.setItem(MOCK_PERMISSIONS, JSON.stringify(newPerms));
export const removeMockPerms = () => localStorage.removeItem(MOCK_PERMISSIONS);

export const setSelectedOrgLS = (
	newSelectedOrg: OrgAndPermsDto,
	newOrgs?: Array<OrgAndPermsDto>
) => {
	const newUserOrgs =
		newOrgs || userOrgsLS().filter((org) => org.id !== newSelectedOrg.id);

	newUserOrgs.unshift(newSelectedOrg as OrgAndPermsDto);

	localStorage.setItem(USER_ORGS, JSON.stringify(newUserOrgs));
	localStorage.setItem(SELECTED_ORG, JSON.stringify(newSelectedOrg));

	return { newSelectedOrg, newUserOrgs };
};

export const getLastRoute = (isLogOut = false) => {
	const lastRoute = sessionStorage.getItem(LAST_ROUTE);
	if (lastRoute) {
		if (isLogOut) {
			if (lastRoute.startsWith(routes.registerSubscription.path)) {
				return lastRoute;
			}

			return routes.home.path;
		}

		sessionStorage.removeItem(LAST_ROUTE);
		return lastRoute;
	}

	if (isLogOut) {
		return routes.home.path;
	}

	return routes.presentation.path;
};
